import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/ui/select'
import type { BusinessListItem } from '@/features/businesses'

interface CreditsBusinessPickerProps {
  businesses: BusinessListItem[]
  value: string | undefined
  onChange: (businessId: string) => void
  disabled?: boolean
}

/** Selector del negocio cuyo balance/historial se muestra. */
export function CreditsBusinessPicker({
  businesses,
  value,
  onChange,
  disabled,
}: CreditsBusinessPickerProps) {
  return (
    <div className="w-full sm:max-w-sm">
      <label className="mb-1.5 block text-xs font-medium text-ink-muted">Negocio</label>
      <Select value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger>
          <SelectValue placeholder="Selecciona un negocio" />
        </SelectTrigger>
        <SelectContent>
          {businesses.map((b) => (
            <SelectItem key={b.id} value={b.id}>
              {b.legalName}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
